<template>
     <div ref="ddl-list-area"
        class="absolute left-0 w-full bg-white border rounded-md overflow-hidden z-index-dropdown"
        :class="[isBottomDropdown ? 'top-16' : 'bottom-16']">
        <div class="max-h-64 overflow-y-auto hide-scroll">
            <div v-for="(v) in itemList" :key="v.value"
                class="py-2 px-4 cursor-pointer hover:bg-gray-50 text-20 text-a-blue-1c3e95"
                @click="selectItem(v)">
                {{v.text}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MenuProfileDropdown',
    props:{
        itemList: Array
    },
    data() {
        return {
            isBottomDropdown: true,
            itemSelected: null,
            showList: false,
        };
    },
    methods: {
        selectItem: function(item){
            this.$emit('select:drowdown' ,item)
        },
         openDropdown: function() {
            this.isBottomDropdown = true;
            this.showList = true;
            document.addEventListener('click', this.documentClick);
            console.log('open dropdown')
            this.$nextTick(() => {
                let elem = this.$refs['ddl-list-area'];
                let bottom = elem.getBoundingClientRect().bottom;
                let windowHeight = window.innerHeight;

                this.isBottomDropdown = bottom < windowHeight;
            });
        },
        closeDropdown: function() {
            this.showList = false;
            document.removeEventListener('click', this.documentClick);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
